import { client } from "../client";
import {
  buildEntityPayload,
  buildMutationEntityPayload,
  buildPaginatedEntityPayload,
  buildSearchEntityPayload,
  buildSignalConfig,
} from "../utils/entityRequests";

const CLIENT_FIELDS = ["name", "address", "email", "phone"];
const CLIENT_UPDATE_FIELDS = [...CLIENT_FIELDS, "status"];
const CLIENT_LOGIN_FIELDS = ["clientIdLogin", ...CLIENT_FIELDS];

export const getClient = (params) => {
  return client.post(
    "/query",
    buildPaginatedEntityPayload("client", params),
    buildSignalConfig(params)
  );
};

export const searchClient = (params) => {
  return client.post(
    "/search",
    buildSearchEntityPayload("client", params),
    buildSignalConfig(params)
  );
};

export const addClient = (params) => {
  return client.post("", buildMutationEntityPayload("client", params, CLIENT_FIELDS));
};

export const updateClient = (params) => {
  return client.patch(
    `/${params.id}`,
    buildMutationEntityPayload("client", params, CLIENT_UPDATE_FIELDS)
  );
};

export const getClientId = () => {
  return client.post("/info", {});
};


export const generateCSVClient = (params) => {
  return client.post("/export", {});
};

export const addClientByClientUser = (params) => {
  return client.post(
    "/by-login",
    buildMutationEntityPayload("client", params, CLIENT_LOGIN_FIELDS)
  );
};

export const getClientsByClientUser = (params) => {
  return client.post(
    "/by-login/query",
    buildPaginatedEntityPayload("client", params, {
      name: params?.name,
      clientIdLogin: params?.clientIdLogin,
    }),
    buildSignalConfig(params)
  );
};

export const getClientSearch = (params) => {
  return client.post(
    "/by-login/search",
    buildSearchEntityPayload("client", params, {
      clientIdLogin: params?.clientIdLogin,
    }),
    buildSignalConfig(params)
  );
};

export const getClientsForClient = (params) => {
  return client.post(
    "/by-login/all",
    buildEntityPayload("client", {
      clientIdLogin: params?.clientIdLogin,
    })
  );
};

